import { Component } from 'react';
import WorkoutModule from './WorkoutModule';
import { GeneralObserver } from './Observer';

class WorkoutsModule extends Component {

	constructor(props) {
		super(props);

		this.state = {
			id: -1,
			boardID: this.props.boardID,
			controller: this.props.controller,
			workouts: [],
		}

		this.observer = false;
		this.bindFunctions();
	}

	bindFunctions() {
		this.reactFn = this.reactFn.bind(this);
	}

	componentDidMount() {
		this.initialSetup();
	}

	// Setup obser and subscrive to events from controller
	// Fetch data from controller
	initialSetup() {
		const ctrl = this.state.controller;
		this.observer = new GeneralObserver(this.reactFn);

		ctrl.addObserver(this.observer);
		ctrl.fetchData();

		this.setState({
			controller: ctrl
		});
	}

	// React to controller events
	// Sets controller and workouts
	reactFn() {
		const ctrl = this.state.controller;
		const newData = ctrl.getWorkouts();

		this.setState({
			controller: ctrl,
			workouts: newData
		});
	}

	// Renders dummy content while reloading
	renderDummyContent() {
		return (
			<div>
					<div className="workout dummy">
						
						<div className="workout-progress dummy">
							<div className="workout-progress__circle-dummy shimmer"></div>
							<div className="workout-progress__current-day shimmer"></div>
						</div>

						<div className="workout__routines">
							<div className="workout__routine">
								<div className="h5 workout__routine__name shimmer"></div>
								<div className="h5 workout__routine__reps shimmer"></div>
							</div>
							<div className="workout__routine">
								<div className="h5 workout__routine__name shimmer"></div>
								<div className="h5 workout__routine__reps shimmer"></div>
							</div>
							<div className="workout__routine">
								<div className="h5 workout__routine__name shimmer"></div>
								<div className="h5 workout__routine__reps shimmer"></div>
							</div>
							<div className="workout__routine">
								<div className="h5 workout__routine__name shimmer"></div>
								<div className="h5 workout__routine__reps shimmer"></div>
							</div>
							<div className="workout__routine">
								<div className="h5 workout__routine__name shimmer"></div>
								<div className="h5 workout__routine__reps shimmer"></div>
							</div>
							<div className="workout__routine">
								<div className="h5 workout__routine__name shimmer"></div>
								<div className="h5 workout__routine__reps shimmer"></div>
							</div>

						</div>

					</div>
			</div>
		);
	}

	render() {
		const ctrl = this.state.controller;
		if ( !ctrl ) {
			return false;
		}

		const reloading = this.props.reloading;
		const renderContent = !reloading;

		const workouts = ctrl.getWorkouts();
		const hasWorkouts = workouts.length > 0;

		if ( reloading ) {
			return (
				<div className={ this.moduleName }>
					{ this.renderDummyContent() }
				</div>
			)
		}

	    return (
	    		<div>
		    		<div>
		    			{
		    				hasWorkouts && renderContent &&
		    				Object.keys(workouts).map(key => (
			    				<div key={key}>
									<WorkoutModule contents={workouts[key]} data={workouts[key]} />
							    </div>
				    		))
				    	}
			    	</div>
			    </div>
	    );
  	}
}

export default WorkoutsModule;